import { render } from "./LayoutInvoice.vue?vue&type=template&id=b56f6a18"
const script = {}

import "./LayoutInvoice.vue?vue&type=style&index=0&id=b56f6a18&lang=sass"
script.render = render

export default script